module.exports = __webpack_public_path__ + "img/mapping.2dc3740e.png";